/* 用户相关 */
import { setStorage, getStorage, batchSetStorage, saveAccount, getAccount, isAndroid, IdCodeValid } from '@/libs/utils';
import CryptoJS from 'crypto-js';

import moment from 'moment';
import { Toast } from 'vant';
import {
  ysdkStatus,
  huaweiLogin,
  login,
  btLoginApi,
  register,
  phoneRegister,
  captchaRegister,
  checkAntiIndulged,
  idBindCheck,
  antiIndulged as antiIndulgedBeat,
  quickRegister,
  userStatus,
  checkVip,
  cellCredentialLoginApi,
  cellSmsLoginApi,
  getBoxDownloadUrlApi,
  silentLogin
} from '@/api/user';
import { affiche } from '@/api/activity';
import { jsDataStorage, registScreenShotingFunction, syGetOaid } from '@/bridge/AppJsBridge';
import { cpsRegister } from '@/libs/business/cpsReport'
import { redirBoxNewVersion } from '@/libs/business/version'

const state = {
  /* H5部分单独使用 */
  thirdLoginVisible: false, // 是否显示三方渠道登录框(应用宝qq,微信)
  gameVisible: false, // 游戏Iframe是否显示
  suspendVisible: false, // 是否显示悬浮球
  floatWindowVisible: false, // 是否显示悬浮窗
  chargeVisible: false, // 是否显示支付窗口
  customerVisible: false, // 是否显示客服窗口
  personalVisible: false, // 是否显示个人中心
  arrivedVisible: false, // 是否显示悬浮窗礼包界面
  officialWechatVisible: false, // 是否显示悬浮窗关注公众号
  vipVisible: false, // 是否显示vip界面
  actSuspendVisible: false, // h5是否显示活动悬浮球
  recommendVisible: false, // 新游推荐
  forceOfflineVisible: false, // 冻结账号强制下线弹窗
  updateGiftVisible: false, // 是否显示强更礼包
  background: '', // H5背景图
  h5Preload: false, // h5包是否开启预加载
  float_position: 0, // 悬浮窗默认位置 0. 左侧 1.右侧
  float_bubble_status: 0, // 气泡状态 0.无气泡配置 1.存在气泡配置
  float_bubble: {}, // 气泡配置，气泡状态为1情况下存在
  silentHintShow: false, // 静默登录成功提示
  iosTips: false, // iOS手机苹果浏览器添加桌面提示
  /* -------------------- */
  /*  原生单独使用   */

  /*  ----------------   */
  /*      通用部分        */
  official_status: 0, // 悬浮菜单是否显示公众号
  close_update: 0, // 强更后点击暂不更新值变为1，登录接口用到
  loginVisible: true, // 是否显示登录框
  cellLoginVisible: false, // 是否显示v2版本手机号优先登录登录框
  yybLoginVisible: false, // 是否显示应用宝登录窗口
  quickRegisterVisible: false, //  是否显示快速注册框
  cellRegisterVisible: false, // 是否显示手机注册框
  resetVisible: false, // 是否显示重置密码
  captchaVisible: false, // 是否显示滑块验证码
  forceBindVisible: false, // 是否显示强制绑定手机提示
  argumentVisible: false, // 是否显示用户协议
  argumentTipVisible: false, // 是否显示用户协议
  argumentType: 0, // 协议类型 0.用户协议 1.隐私协议
  quickRegisterAccount: {
    username: '',
    password: ''
  }, // 快速注册账号
  afficheShow: false, // 是否显示公告
  forceUpdateVisible: false, // 是否显示强制更新
  affiche_info: null, // 公告接口返回公告信息，若没有则表示无公告
  login_status: '', // 登录状态,默认为空 只有当应用宝包登录接口返回为2时需存储到缓存中，下次登录强制为正常登录框并传次参数到登录接口
  sdk_version: '', // 客户端sdk版本
  device_info: '', // 设备信息，即客户端传过来的attributeReportParams
  appkey: '', // appkey
  channel: '', // 渠道
  extra_data: '', // 部分接口需要，额外的设备信息 json字符串格式
  game_version: '', // 游戏版本
  third_sdk_status: '', // 三方登录渠道判断
  app_name: '', // app名称
  p_name: '', // 主游戏名称
  captcha_status: '', // 滑块验证码开关
  ysdk_status: '', // 应用宝相关处理
  username: '', // 用户名
  password: '', // 密码
  session_id: '', // 传给研发进行二次验证使用
  force_update_info: {}, // 开启强更后，强制更新信息
  user_id: '', // 用户ID
  game_url: '', // 游戏链接
  tel_status: '', // 手机绑定状态 0 未绑定 1 已绑定
  tel_num: '', // 若绑定手机，对应绑定的手机号
  id_card_status: '', // 实名认证状态
  app_status: '', // 当前游戏状态 0 正常 1 审核 2 关闭
  access_token: '', // token 部分接口校验使用
  register_time: '', // 注册时间
  force_bind_tel: '', // 强制绑定手机判断 0不做处理 1强制绑定 2提示绑定（可关闭）3提示明日将强制绑定
  is_vip: 0, // 0.非vip 1.vip
  vip_type: 1, // 1.工单后台达到vip金额线 2。vip后台推送为vip
  server: '', // 服务器
  role_name: '', // 角色名
  open_id: '', // 公众号内打开(客服页)授权后获取
  update_gift_status: '',
  update_gift_code: '',
  update_gift_icon: '',
  channel_status: '', // 头条包是否登录勾选协议判断
  /*  ----------------   */
  /*       防沉迷相关       */
  antiIndulgedVisible: false, // 是否显示防沉迷相关界面
  antiIndulgedInfo: null, // 防沉迷接口返回信息暂存
  antiIndulgedPayInfo: null, // 支付相关防沉迷接口返回信息暂存
  h5_branch: 'login', // h5使用的分支类型 login 登录 payment 支付
  quit_type: 0, // 0.非cp通知 1.cp通知游客模式时长到达上限 2.cp通知未成年用户游戏时长到达上限
  antiInduled_customer: '',
  h5AntiIndulgedResult: {
    is_bind_ID_card: 1, // 0 未绑定 1,.已绑定
    is_adult: 1 // 0 未成年 1 已成年
  }, // h5通知游戏防沉迷相关字段，默认已绑定身份证，已成年
  bindIdCardCallback: null, // 判断cp是否有防沉迷相关处理
  idBindCheckState: false, // 当前用户是否需要重新进行真实实名认证
  verify_customer_state: 0, // 当钱包是否屏蔽防沉迷客服
  /* ------------------ */
};

const mutations = {
  CHANGE_STATE: (state, obj) => {
    state = Object.assign(state, obj);
  },
  handleLoginResult: (state, r) => {
    const { login_status } = r.content;
    // 登录接口返回的原值key和对应需要存储的key, 一一对应
    const origin = [
      'app_key',
      'user_id',
      'code',
      'game_url',
      'tel_status',
      'tel_num',
      'user_name',
      'id_card_status',
      'app_status',
      'access_token',
      'register_time',
      'force_bind_tel',
      'force_bind_text',
      'official_status',
      'update_gift_status',
      'update_gift_code',
      'update_gift_icon'
    ];
    const target = [
      'appkey',
      'user_id',
      'session_id',
      'game_url',
      'tel_status',
      'tel_num',
      'username',
      'id_card_status',
      'app_status',
      'access_token',
      'register_time',
      'force_bind_tel',
      'force_bind_text',
      'official_status',
      'update_gift_status',
      'update_gift_code',
      'update_gift_icon'
    ];
    switch (login_status) {
      case 5:
        // 强更活动
        state.force_update_info = r.content;
        state.forceUpdateVisible = true;
        saveAccount(state.username, state.password);
        break;
      case 2:
        // 应用宝强制正常登录
        setStorage('force_normal_login', true);
        state.yybLoginVisible = false;
        state.loginVisible = true;
        break;
      default:
        // 存储登录结果
        origin.forEach((item, index) => {
          state[target[index]] = r.content[item];
          setStorage(target[index], r.content[item]);
        });
        if (!r.isCellLogin) {
          batchSetStorage({
            password: state.password
          });
          if (state.username && state.password) {
            saveAccount(state.username, state.password);
          }
        }
    }
  },
  // h5通知cp当前用户完成了实名认证
  notifyCpBindIdCard(state, is_adult) {
    if (!state.bindIdCardCallback) return;
    // 3 成年 2 未成年 通知研发为 1 成年 0 未成年
    const n = {
      action: state.bindIdCardCallback,
      params: is_adult == 3 ? 1 : 0
    };
    window.frames['gameFrame'] && window.frames['gameFrame'].postMessage(n, '*');
  }
};

const actions = {
  /**
   * 缓存账户数据
   * @param {Array} cacheList state中需要缓存的key值列表
   */
  async cacheState({ state }, cacheList) {
    const cacheObj = {};
    cacheList.forEach((key) => {
      cacheObj[key] = state[key];
    });
    await batchSetStorage(cacheObj);
  },
  /**
   * 获取缓存的账户
   * @param {Array} cacheList 需要读取的缓存的key值列表
   */
  async getCacheState({ commit }, cacheList) {
    // 默认读取列表
    const defaultCacheList = [
      'access_token',
      'appkey',
      'channel',
      'device_info',
      'extra_data',
      'force_bind_tel',
      'game_version',
      'id_card_status',
      'register_time',
      'sdk_version',
      'session_id',
      'tel_status',
      'tel_num',
      'third_sdk_status',
      'user_id',
      'username',
      'password',
      'app_name',
      'p_name',
      'server',
      'role_name',
      'official_status',
      'is_vip',
      'captcha_status'
    ];
    if (!cacheList) cacheList = defaultCacheList;
    cacheList.map((key) => {
      const val = getStorage(key);
      val && commit('CHANGE_STATE', { [key]: val });
    });
  },
  /**
   * 获取应用信息
   */
  async getYsdkStatus({ state, commit, dispatch }) {
    const r = await ysdkStatus(state.appkey);
    const { ysdk_status, captcha_status, appname, p_name, background, channel_status, box_status, h5_game_page, preload, pid } = r.content;
    await commit('CHANGE_STATE', {
      app_name: appname,
      captcha_status,
      ysdk_status,
      p_name: p_name,
      background: background || '',
      channel_status: channel_status,
      float_position: r.content.float_position,
      float_bubble_status: r.content.float_bubble_status,
      float_bubble: r.content.float_bubble
    });
    setStorage('captcha_status', captcha_status);
    setStorage('app_name', appname);
    setStorage('p_name', p_name); // 缓存主游戏名称
    setStorage('box_status', box_status); // 接口判断是否是玩心盒子渠道包
    setStorage('cloud_relation_status', r.content.cloud_relation_status); // 云挂机用关联状态 0无关联 1BT盒子关联 2玩心盒子关联
    setStorage('private_status', r.content.private_status);
    setStorage('user_private_protect_policy', r.content.user_private_protect_policy);
    setStorage('user_service_policy', r.content.user_service_policy);
    setStorage('pid', pid);
    if (redirBoxNewVersion()) {
      // 原生4.4.0、h54.5.4之后 兼容为通过接口判断盒子游戏类型，新游、礼包下载盒子用到
      if (box_status == 1) {
        setStorage('game_type', 'boxGame');
      } else if (box_status == 2) {
        setStorage('game_type', 'wxBoxGame');
      }
    }
    // 应用宝相关处理
    const forceNormalLogin = getStorage('force_normal_login');
    const thirdPlatform = getStorage('android_third_platform');
    if (ysdk_status == 0 && thirdPlatform === 'yyb' && !forceNormalLogin) {
      commit('CHANGE_STATE', {
        yybLoginVisible: true,
        loginVisible: false
      });
    } else if (ysdk_status != 0) {
      // commit('CHANGE_STATE', {
      //   loginVisible: true
      // });
    }
    if (preload === 1) {
      dispatch('message/monitorInit', null, { root: true });
      commit('CHANGE_STATE', {
        gameVisible: true,
        game_url: h5_game_page,
        h5Preload: true
      })
    }
  },
  // 获取公告信息
  async affiche({ state, commit }) {
    /**
     * @return { login_state 0.登录后 1.登录前 }
     * @return { open 0.不可关闭 1.可以关闭 }
     */
    try {
      const r = await affiche({ appkey: state.appkey });
      commit('CHANGE_STATE', { affiche_info: r.content });
      if (r.content.login_state == 1) commit('CHANGE_STATE', { afficheShow: true });
    } catch (error) { }
  },
  // 用户登录
  async login({ state, commit }) {
    commit('global/showLoading', null, { root: true });
    const device_id = isAndroid() ? state.device_info.uuid : state.device_info.device_id;
    const forceNormalLogin = getStorage('force_normal_login');
    const close_update = sessionStorage.getItem('close_update');
    let r = null;
    try {
      r = await login({
        user_name: state.username.toString(),
        password: CryptoJS.MD5(state.password + CryptoJS.MD5(state.password)).toString(),
        jh_app_id: state.appkey,
        jh_channel: state.channel,
        device_id: device_id,
        time: moment().unix(),
        extra_data: state.extra_data,
        close_update: close_update || '',
        login_status: forceNormalLogin
      });
    } catch (error) {
      setTimeout(() => {
        commit('global/clearLoading', null, { root: true });
      }, 1000)
      return Promise.reject();
    }
    // 登录后公告判断，若登录后不可关闭则不需要进入游戏了
    if (state.affiche_info) {
      const { login_state, open } = state.affiche_info;
      if (login_state == 0) {
        state.afficheShow = true;
        commit('global/clearLoading', null, { root: true });
      }
    }
    // 处理登录结果
    commit('handleLoginResult', r);
    return r;
  },
  // v2手机登录
  async cellLogin({ state, commit }, form) {
    commit('global/showLoading', null, { root: true });
    const device_id = isAndroid() ? state.device_info.uuid : state.device_info.device_id;
    const close_update = sessionStorage.getItem('close_update');
    let r = null;
    try {
      if (form.credential) {
        r = await cellCredentialLoginApi({
          tel_num: form.tel_num,
          login_credential: form.credential,
          jh_app_id: state.appkey,
          jh_channel: state.channel,
          extra_data: state.extra_data,
          device_id,
          time: moment().unix(),
          close_update: close_update || '',
        });
      } else {
        r = await cellSmsLoginApi({
          tel_num: form.tel_num,
          code: form.smsCode,
          type: localStorage.getItem('cellLoginCodeType'),
          jh_app_id: state.appkey,
          jh_channel: state.channel,
          extra_data: state.extra_data,
          close_update: close_update || '',
        });
      }
    } catch (error) {
      setTimeout(() => {
        commit('global/clearLoading', null, { root: true });
      }, 1500);
      return Promise.reject(error);
    }
    // 登录后公告判断，若登录后不可关闭则不需要进入游戏了
    if (state.affiche_info) {
      const { login_state, open } = state.affiche_info;
      if (login_state == 0) {
        state.afficheShow = true;
        commit('global/clearLoading', null, { root: true });
      }
    }

    // 手机号登录产生注册，上报安卓注册日志
    if (r.content.is_register) {
      registScreenShotingFunction({
        user_name: form.tel_num,
        pwd: '',
        user_id: r.content.user_id
      });
    }

    // 处理登录结果
    commit('handleLoginResult', {
      ...r,
      isCellLogin: true
    });
    return r;
  },
  // 华为包提审使用登录方式
  async huaweiThirdLogin({ state, commit }, data) {
    const r = await huaweiLogin({
      appkey: state.appkey,
      channel: state.channel,
      extra_data: state.extra_data,
      ts: data.ts,
      playerId: data.playerId,
      playerLevel: data.playerLevel,
      playerSSign: data.playerSSign,
      appId: data.appId
    });
    commit('CHANGE_STATE', {
      thirdLoginVisible: false
    });
    commit('handleLoginResult', r);
  },
  // 获取快速注册账号
  async getQuickAccount({ commit, state }) {
    const r = await quickRegister({
      jh_channel: state.channel,
      jh_app_id: state.appkey
    });
    const { password, user_name } = r.content;
    commit('CHANGE_STATE', {
      username: user_name,
      password
    });
    // 缓存快速注册账号
    setStorage('quick_register_account', {
      username: user_name,
      password
    });
  },
  // 用户快速注册
  async quickRegister({ commit, state, dispatch, rootState }, validData) {
    commit('global/showLoading', null, { root: true });
    let r = null;
    try {
      const validation_id = (getStorage('validation_id')) || '';
      let params = {
        jh_channel: state.channel,
        jh_app_id: state.appkey,
        user_name: state.username.toString(),
        password: CryptoJS.MD5(state.password + CryptoJS.MD5(state.password)).toString(),
        extra_data: state.extra_data,
        op: state.device_info.op,
        validation_id
      };
      if (validData) {
        params = { ...params, ...validData };
        r = await captchaRegister(params);
      } else {
        r = await register(params);
      }
    } catch (error) {
      commit('global/clearLoading', null, { root: true });
      setStorage('quick_register_account', null);
      return Promise.reject();
    }
    setStorage('validation_id', r.content.validation_id);
    setStorage('quick_register_account', null);

    registScreenShotingFunction({
      user_name: state.username,
      pwd: state.password,
      user_id: r.content.user_id
    });
    const cpsChannel = localStorage.getItem('cpsChannel');
    if (cpsChannel) {
      cpsRegister[cpsChannel] && cpsRegister[cpsChannel](r.content.user_id)
    }
  },
  // 用户手机注册
  async cellRegister({ commit, state }, form) {
    commit('global/showLoading', null, { root: true });
    let r = null;
    try {
      let params = {
        tel_num: form.tel_num.toString(),
        code: form.smsCode,
        password: CryptoJS.MD5(form.password + CryptoJS.MD5(form.password)).toString(),
        jh_channel: state.channel,
        jh_app_id: state.appkey,
        extra_data: state.extra_data
      };
      // 滑块相关参数
      if (form.validData) params = { ...params, ...form.validData };
      r = await phoneRegister(params);
    } catch (error) {
      commit('global/clearLoading', null, { root: true });
      return Promise.reject();
    }
    commit('CHANGE_STATE', {
      username: form.tel_num,
      password: form.password
    });
    registScreenShotingFunction({
      user_name: state.username,
      pwd: state.password,
      user_id: r.content.user_id
    });
    const cpsChannel = localStorage.getItem('cpsChannel');
    if (cpsChannel) {
      cpsRegister[cpsChannel] && cpsRegister[cpsChannel](r.content.user_id)
    }
  },
  // ios h5通过链接参数初始化
  async initDeviceData({ commit, state, dispatch }, routeQuery) {
    const initData = JSON.parse(routeQuery.initial);
    commit('CHANGE_STATE', {
      game_version: routeQuery.game_version || '3.41.0',
      channel: 'appstore',
      appkey: routeQuery.appid,
      sdk_version: initData.sdk_version || '3.3.6',
      extra_data: JSON.stringify({
        system_version: initData.osversion || '0',
        os: 'iOS',
        imei: initData.idfv || '0',
        device_id: initData.device_id || '0',
        jh_channel: 'appstore',
        client_ip: initData.client_ip || '0',
        ext: '',
        IPADDRESS: initData.inip || '0',
        sdk_version: initData.sdk_version || '3.3.6',
        system_name: initData.devicetype || '0',
        idfv: initData.idfv || '0',
        caid: initData.caid || 'null'
      }),
      device_info: {
        what: 'NULL',
        op: initData.op || '0',
        time: new Date().getTime(),
        devicetype: initData.devicetype || '0',
        device_id: initData.device_id || '0',
        uuid: initData.uuid || '0',
        transactionid: 'NULL',
        resolution: initData.resolution || '0',
        os: 'ios',
        zfmenttype: 'NULL',
        bundleid: 'com.yuewanUrl.UnionSDK',
        inip: initData.inip || '0',
        istablet: initData.isPad || initData.istablet || '0',
        idfv: initData.idfv || '0',
        zftype: 'NULL',
        network: initData.network || '0',
        who: 'NULL',
        osversion: initData.osversion || '0',
        currencyamount: 'NULL',
        wifiname: initData.wifiname || '0',
        language: initData.language || '0'
      }
    });
    const IS_DEV_ENVIRONMENT =
      window.location.hostname == 'h5.yxcgg63.com' || process.env.NODE_ENV === 'development';
    if (initData.os && initData.os === 'Android') {
      commit('CHANGE_STATE', {
        extra_data: JSON.stringify(initData),
        device_info: {
          what: 'NULL',
          op: initData.op || '0',
          time: new Date().getTime(),
          devicetype: initData.devicetype || '0',
          device_id: initData.device_id || '0',
          uuid: initData.uuid || '0',
          transactionid: 'NULL',
          resolution: initData.resolution || '0',
          os: 'Android',
          zfmenttype: 'NULL',
          bundleid: 'com.yuewanUrl.UnionSDK',
          inip: initData.inip || '0',
          istablet: initData.isPad || initData.istablet || '0',
          idfv: initData.idfv || '0',
          zftype: 'NULL',
          network: initData.network || '0',
          who: 'NULL',
          osversion: initData.osversion || '0',
          currencyamount: 'NULL',
          wifiname: initData.wifiname || '0',
          language: initData.language || '0'
        }
      });
    }

    // 针对某些包通过query单独传idfa做处理
    if (routeQuery.idfa) {
      commit('changeAccountStateList', {
        device_info: Object.assign(state.device_info, {
          idfv: routeQuery.idfa,
          device_id: routeQuery.idfa
        }),
        extra_data: Object.assign(state.extra_data, {
          device_id: routeQuery.idfa
        })
      });
    }
    // 缓存信息
    const cacheList = [
      'login_status',
      'sdk_version',
      'device_info',
      'appkey',
      'channel',
      'extra_data',
      'game_version',
      'third_sdk_status'
    ];
    dispatch('cacheState', cacheList);
    dispatch('getYsdkStatus', 1);
    dispatch('pay/judgePayType', null, { root: true });
    dispatch('affiche');
    // dispatch("getPayType");
  },
  // 实名认证前的验证
  realNameVerify({ }, { id_card_name, id_card_num }) {
    return new Promise(resolve => {
      const is = IdCodeValid(id_card_num);
      let msg = '';
      if (!id_card_name.match(/^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/)) {
        msg = '请输入正确的姓名';
      } else if (is.pass != true) {
        if (is.msg == 1) {
          //身份证号格式错误
          msg = '身份证号格式错误';
        } else if (is.msg == 2) {
          //身份证号地址编码错误
          msg = '身份证号地址编码错误';
        } else if (is.msg == 3) {
          //身份证号校验位错误
          msg = '身份证号校验位错误';
        }
      }
      resolve(msg);
    });
  },
  // 检查防沉迷
  async checkAntiIndulged({ commit, state, dispatch }) {
    const { appkey, device_info, user_id } = state;
    const device_id = isAndroid() ? device_info.uuid : device_info.device_id;
    const r = await checkAntiIndulged({ appkey, device_id, user_id });
    const { open, fatigue_state, user_info, verify_customer_state } = r.content;
    commit('CHANGE_STATE', { verify_customer_state: verify_customer_state });
    if (user_info) {
      commit('CHANGE_STATE', { antiInduled_customer: user_info.customer });
      dispatch('cacheState', ['antiInduled_customer']);
    }
    let idBindCheckState = false;
    if (state.id_card_status) {
      idBindCheckState = await dispatch('idBindCheck', { uid: user_id, appkey, device_id });
      commit('CHANGE_STATE', { idBindCheckState });
    }
    if ((!user_info || user_info.id_status == 3) && !idBindCheckState) {
      // 防沉迷关,实名认证关 或 用户已实名并且成年  玩家直接进入游戏
      return Promise.reject();
    } else {
      commit('CHANGE_STATE', { antiIndulgedInfo: r.content });
      return Promise.resolve(r.content);
    }
  },
  // 真实实名认证检查
  async idBindCheck({ }, params) {
    try {
      const r = await idBindCheck(params);
      return Promise.resolve(r.content.rebind);
    } catch (error) {
      return Promise.resolve(false);
    }
  },
  // h5防沉迷轮询接口 1.在二次验证判断后轮询调用 2.若cp处理防沉迷，在cp通知打开防沉迷弹窗后调用，通知服务端玩家游戏时间到了
  async antiIndulged({ state, commit, rootState }) {
    const { appkey, device_info, user_id, quit_type, access_token, extra_data } = state;
    const device_id = isAndroid() ? device_info.uuid : device_info.device_id;
    let polling = null;
    // 研发不提供防沉迷处理，sdk轮询处理
    const pollFc = async () => {
      const params = {
        appkey: appkey,
        user_id: user_id,
        device_id: device_id,
        access_token: access_token,
        extra_data: extra_data,
        role_id: rootState.suspend.role.role_id,
        role_name: rootState.suspend.role.role_name,
        server_id: rootState.suspend.role.server_id,
        server_name: rootState.suspend.role.server_name,
      };
      try {
        const r = await antiIndulgedBeat(params);
        const { result } = r.content;
        switch (result) {
          case 0:
            clearInterval(polling);
            break;
          case 1:
            break;
          case 3:
            commit('CHANGE_STATE', {
              quit_type: 2,
              h5_branch: 'login',
              antiIndulgedVisible: true
            });
            break;
          case 4:
            commit('CHANGE_STATE', {
              quit_type: 1,
              h5_branch: 'login',
              antiIndulgedVisible: true
            });
            break;
          default:
            break;
        }
      } catch (error) {
        polling && clearInterval(polling);
      }
    };
    pollFc();
    polling = setInterval(pollFc, 60 * 1000 * 2);
  },
  // 检查vip
  async checkVip({ state, commit }) {
    try {
      const r = await checkVip({ game_id: state.appkey, user_id: state.user_id });
      commit('CHANGE_STATE', {
        is_vip: r.code,
        vip_type: r.type
      });
      batchSetStorage({
        is_vip: r.code,
        vip_type: r.type
      });
    } catch (error) {
      commit('CHANGE_STATE', { is_vip: 0 });
      setStorage('is_vip', 0);
    }
  },
  // 冻结账号强制下线轮训判断 5分钟一次
  async blockDiagnose({ state, commit }) {
    const { user_id } = state
    let looping = null;
    const loopFc = async () => {
      const r = await userStatus({ user_id });
      const {
        content: { status }
      } = r;
      if (status === 0) {
        commit('CHANGE_STATE', { forceOfflineVisible: true });
        looping && clearInterval(looping);
      }
    };
    loopFc();
    looping = setInterval(loopFc, 60 * 1000 * 5);
  },
  // bt盒子授权登录
  async btLogin({ state, commit }, code) {
    const device_id = isAndroid() ? state.device_info.uuid : state.device_info.device_id;
    let r = null;
    try {
      r = await btLoginApi({
        code,
        jh_app_id: state.appkey,
        jh_channel: state.channel,
        device_id: device_id,
        time: moment().unix(),
        extra_data: state.extra_data
      });
    } catch (error) {
      commit('global/clearLoading', null, { root: true });
      return Promise.reject();
    }
    // 处理登录结果
    commit('handleLoginResult', r);
    return r;
  },
  // ios三方买包设备信息处理 要做激活上报
  async initIosThirdDeviceData({ commit, state, dispatch }, routeQuery) {
    const { idfa, idfv, initial, devicetype, inip, osversion } = routeQuery;
    if (initial) {
      const initData = JSON.parse(routeQuery.initial);
      commit('CHANGE_STATE', {
        game_version: routeQuery.game_version || '3.16.3',
        channel: 'appstore',
        appkey: routeQuery.appid,
        sdk_version: initData.sdk_version || '3.16.3',
        extra_data: JSON.stringify({
          system_version: initData.osversion || '0',
          os: 'iOS',
          imei: initData.idfv || '0',
          device_id: initData.device_id || '0',
          jh_channel: 'appstore',
          ext: '',
          IPADDRESS: initData.inip || '0',
          client_ip: initData.client_ip || '',
          sdk_version: initData.sdk_version || '3.16.3',
          system_name: initData.devicetype || '0',
          idfv: initData.idfv || '0',
        }),
        device_info: {
          what: 'NULL',
          op: initData.op || '0',
          time: new Date().getTime(),
          devicetype: initData.devicetype || '0',
          device_id: initData.device_id || '0',
          uuid: initData.uuid || '0',
          transactionid: 'NULL',
          resolution: initData.resolution || '0',
          os: 'ios',
          zfmenttype: 'NULL',
          bundleid: 'com.yuewanUrl.UnionSDK',
          inip: initData.inip || '0',
          istablet: initData.isPad || initData.istablet || '0',
          idfv: initData.idfv || '0',
          zftype: 'NULL',
          network: initData.network || '0',
          who: 'NULL',
          osversion: initData.osversion || '0',
          currencyamount: 'NULL',
          wifiname: initData.wifiname || '0',
          language: initData.language || '0'
        }
      });
    } else {
      commit('CHANGE_STATE', {
        game_version: routeQuery.game_version || '3.41.0',
        channel: 'appstore',
        appkey: routeQuery.appid,
        sdk_version: '3.16.3',
        extra_data: JSON.stringify({
          system_version: osversion || '0',
          os: 'iOS',
          imei: idfv || '0',
          device_id: idfa || '0',
          jh_channel: 'appstore',
          ext: '',
          IPADDRESS: '0',
          sdk_version: '3.16.3',
          system_name: devicetype || '0',
          idfv: idfv || '0',
        }),
        device_info: {
          what: 'NULL',
          op: '0',
          time: new Date().getTime(),
          devicetype: devicetype || '0',
          device_id: idfa || '0',
          uuid: '0',
          transactionid: 'NULL',
          resolution: '0',
          os: 'ios',
          zfmenttype: 'NULL',
          bundleid: 'com.yuewanUrl.UnionSDK',
          inip: inip || '9.9.9.9',
          istablet: '0',
          idfv: idfv || '0',
          zftype: 'NULL',
          network: '0',
          who: 'NULL',
          osversion: osversion || '0',
          currencyamount: 'NULL',
          wifiname: '0',
          language: '0'
        }
      });
    }
    // 缓存信息
    const cacheList = [
      'login_status',
      'sdk_version',
      'device_info',
      'appkey',
      'channel',
      'extra_data',
      'game_version',
      'third_sdk_status'
    ];
    dispatch('log/attributeReport', null, { root: true });
    dispatch('cacheState', cacheList);
    dispatch('getYsdkStatus', 1);
    dispatch('pay/judgePayType', null, { root: true });
    dispatch('affiche');
    const cpsChannel = localStorage.getItem('cpsChannel');
    if (cpsChannel) {
      setTimeout(() => {
        dispatch('log/cpsOnActiveReport', null, { root: true });
      }, 1000);
    }
    // dispatch("getPayType");
  },
  // 获取盒子下载链接
  async getBoxDownloadUrl({ state }) {
    const r = await getBoxDownloadUrlApi({ appkey: state.appkey });
    localStorage.setItem('boxDownloadUrl', r.content.url);
  },
  // 刷新Oaid
  refreshOaid({ commit, state },) {
    syGetOaid('', (oaid) => {
      let extra_data = state.extra_data;
      try {
        let _extraData = JSON.parse(extra_data);
        _extraData.oaid = oaid;
        commit('CHANGE_STATE', { extra_data: JSON.stringify(_extraData) });
      } catch (error) { }
    })
  },
  // 静默登录
  async silentLogin({ state, commit }) {
    commit('global/showLoading', null, { root: true });
    const device_id = isAndroid() ? state.device_info.uuid : state.device_info.idfv;
    const login_credential = getStorage('login_credential');
    let r = null;
    try {
      r = await silentLogin({
        jh_app_id: state.appkey,
        jh_channel: state.channel,
        extra_data: state.extra_data,
        op: state.device_info.op,
        silent_device_id: device_id,
        login_credential: login_credential || ''
      });
    } catch (error) {
      commit('global/clearLoading', null, { root: true });
      return Promise.reject();
    }
    setStorage('login_credential', r.content.login_credential);
    // 登录后公告判断，若登录后不可关闭则不需要进入游戏了
    if (state.affiche_info) {
      const { login_state, open } = state.affiche_info;
      if (login_state == 0) {
        state.afficheShow = true;
        commit('global/clearLoading', null, { root: true });
      }
    }
    // 手机号登录产生注册，上报安卓注册日志
    if (r.content.is_register) {
      registScreenShotingFunction({
        user_name: r.content.user_name,
        pwd: '',
        user_id: r.content.user_id
      });
    }
    // 处理登录结果
    commit('handleLoginResult', r);
    return r;
  },
  initExternalData({ commit, state, dispatch }, routeQuery) {
    commit('CHANGE_STATE', {
      game_version: '3.41.0',
      channel: 'debug',
      appkey: routeQuery.appid,
      sdk_version: '3.3.6',
      extra_data: JSON.stringify({
        system_version: '0',
        os: 'Android',
        imei: '0',
        device_id: '0',
        jh_channel: 'debug',
        client_ip: '0',
        ext: '',
        IPADDRESS: '0',
        sdk_version: '3.3.6',
        system_name: '0',
        idfv: '0',
        caid: 'null'
      }),
      device_info: {
        what: 'NULL',
        op: '0',
        time: new Date().getTime(),
        devicetype: '0',
        device_id: '0',
        uuid: '0',
        transactionid: 'NULL',
        resolution: '0',
        os: 'Android',
        zfmenttype: 'NULL',
        bundleid: 'com.yuewanUrl.UnionSDK',
        inip: '0',
        istablet: '0',
        idfv: '0',
        zftype: 'NULL',
        network: '0',
        who: 'NULL',
        osversion: '0',
        currencyamount: 'NULL',
        wifiname: '0',
        language: '0'
      }
    });
    // 缓存信息
    const cacheList = [
      'login_status',
      'sdk_version',
      'device_info',
      'appkey',
      'channel',
      'extra_data',
      'game_version',
      'third_sdk_status'
    ];
    dispatch('cacheState', cacheList);
    dispatch('getYsdkStatus', 1);
    dispatch('pay/judgePayType', null, { root: true });
    dispatch('affiche');
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
